import styled from "styled-components";

export const StyledHideStepsOnMobile = styled.div`
  display: none;

  @media (min-width: 961px) {
    display: block;
  }
`;
export const StyledHideStepOnDesktop = styled.div`
  @media (min-width: 961px) {
    display: none;
  }
`;
